<template>
  <div class="sm-ref">
    <div class="sm-ref__top">
      <div class="sm-ref__top-item">
        <p>Clicks</p>
        <span class="sm-small">Number of times your link has been clicked</span>
        <h4>{{refInfo.clicks}}</h4>
      </div>
      <div class="sm-ref__top-item">
        <p>Sign Ups</p>
        <span class="sm-small">People who have signed up using your link</span>
        <h4>{{refInfo.sign_ups}}</h4>
      </div>
      <div class="sm-ref__top-item">
        <p>Clicks</p>
        <span class="sm-small">Amount that will be applied to your balance</span>
        <h4>{{formatPrice(refInfo.earned)}}</h4>
      </div>
    </div>
    <div class="sm-ref__href">
      <h5>Share this link with a friend</h5>
      <div class="sm-ref__href-flex">
        <div class="sm-ref__href-flex-link">
          <include-svg :name="'icon-href'" />
          <span>{{refInfo.href}}</span>
        </div>
        <btn-block
          :text="'Copy link'"
          @click="copyToClipboard"
        />
      </div>
    </div>
    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import {FormatPrice} from "@/utils/general-data";

export default {
  name: 'tab-referrals',
  components: {
    'sm-spinner': Spinner
  },
  data() {
    return {
      showSpinner: false,
      //TEMP
      refInfo: {
        href: 'spheremail.co/?referral=67f87af8897174e2ae2bdd60ad63da22',
        clicks: 372,
        sign_ups: 223,
        earned: 45692
      }
    };
  },
  created() {
    this.showSpinner = true;

    this.showSpinner = false;
  },
  compoted: {

  },
  methods: {
    formatPrice: FormatPrice,
    copyToClipboard() {
      console.log('click');
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/general/mixins.scss";
@import "@/assets/scss/framework/scss-variables.scss";
@import "@/assets/scss/pages/customer/account/components/_ref.scss";
</style>